import React, { useState } from "react";
import Img_logo from "../../assets/auth/logo.png";
import pass_on from "../../assets/auth/pass-on.png";
import pass_off from "../../assets/auth/pass-off.png";
import Styles from "../../styles/client/login.module.scss";
import { useNavigate, Link } from "react-router-dom";
import { clientRoutes } from "../../routers/ClientRouters";
import { clientLoginService } from "../../services/clientService";
const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email.trim() && password.trim()) {
      const success = await clientLoginService(email, password);
      if (success) {
        navigate(clientRoutes.dashboard);
      }
    } else {
      console.log("An error occurred during login:");
    }
  };

  return (
    <div className={Styles.dashboard_main}>
      <div className={Styles.dashboard_flexmain}>
        <div className={Styles.flexdivider_2}>
          <div className={Styles.flexdivider_2_logo}>
            <img src={Img_logo} alt="admin_dash_logo" />
          </div>

          <div className={Styles.flexdivider_2_formcontainer}>
            <form autoComplete="" onSubmit={handleSubmit}>
              <div className={Styles.flexdivider_2_formcontainer_username}>
                <label className={Styles.label}>Email ID</label>
                <input
                  placeholder="Enter here"
                  required
                  type="email"
                  name="email"
                  minLength={2}
                  maxLength={50}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className={Styles.flexdivider_2_formcontainer_password}>
                <label className={Styles.password}>Password</label>
                <input
                  placeholder="Enter here"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  required
                  minLength={2}
                  maxLength={50}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <div
                  type="button"
                  onClick={togglePasswordVisibility}
                  className={Styles.eyeIcon}
                >
                  <img
                    src={showPassword ? pass_on : pass_off}
                    alt="Toggle password visibility"
                    className={Styles.eyeImage}
                  />
                </div>
              </div>
              <div className={Styles.flexdivlogintext}>
                <p>
                  <span>
                    <Link to={clientRoutes.forgetPassword}>
                      Forget Password ?{" "}
                    </Link>
                  </span>
                </p>
              </div>
              <br />
              <div className={Styles.flexdivider_2_formcontainer_button}>
                <button type="submit">
                  <span>LOGIN</span>
                </button>
              </div>

              <div className={Styles.flexdivloginregistertext}>
                <p>
                  Don’t have an account?
                  <span>
                    <Link to={clientRoutes.register}> Register</Link>
                  </span>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
